export default "__VITE_ASSET__BusYExaB__"